<template>
  <div
    class="campaign-preview-option"
    data-qa="sidebar-workflow-inbox-selector"
  >
    <h3>{{ $t('CampaignForm_Preview_Workflow_Messages') }}</h3>
    <div class="email-select-ct">
      <el-select
        v-if="items.length"
        v-model="selectedId"
        @change="onChange"
        data-qa="sidebar-workflow-inbox-select"
      >
        <el-option
          v-for="item in items"
          :key="item.workflow_action_id"
          :label="formatLabel(item)"
          :value="item.workflow_action_id"
        >
          <el-tooltip
            :open-delay="600"
            :content="formatLabel(item)"
            placement="top"
          >
            <div class="label">
              {{ formatLabel(item) }}
            </div>
          </el-tooltip>
        </el-option>
      </el-select>
      <div v-else data-qa="sidebar-workflow-inbox-empty">
        {{ $t('CampaignForm_Preview_Workflow_NoMessages') }}
      </div>
    </div>
  </div>
</template>

<script>
import { projectEndpoint } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'
import { workflowType as workflowTypeEnum } from '@/modules/campaign-manage/enum/WorkflowTypeEnum'

export default {
  name: 'SidebarWorkflowInboxSelector',

  props: {
    model: {
      type: Object,
      required: true
    },
    variantKey: {
      type: String,
      required: true
    },
    workflowType: {
      type: Number,
      required: false,
      default: workflowTypeEnum.LIVE
    }
  },

  data() {
    return {
      selected: null,
      selectedId: null,
      items: []
    }
  },

  mounted() {
    this.fetchItems()
  },

  methods: {
    formatLabel(item) {
      const lang = item.language ? ` - ${item.language}` : ''
      return `${item.name} - ${item.action_id}${lang}`
    },

    async fetchItems() {
      // prettier-ignore
      const workflowId = this.model.messages[12][this.variantKey]['content']['workflow_id']

      if (!workflowId) {
        this.items = []
        this.selectedId = null
        this.selected = {}
        this.$emit('workflow-inbox-change', this.selected)

        return
      }

      await RestApi(
        projectEndpoint({
          method: 'get',
          url: `workflows/${workflowId}/inbox`,
          params: {
            variantKey: this.variantKey,
            workflowType: this.workflowType
          }
        })
      ).then(({ data }) => {
        this.items = data
        this.selectedId = data[0] ? data[0].workflow_action_id : null
        this.selected = data[0] ? data[0] : {}
        this.$emit('workflow-inbox-change', this.selected)
      })
    },

    onChange(workflowActionId) {
      this.selected = this.items.filter(item => {
        return item.workflow_action_id === workflowActionId
      })[0]

      this.$emit('workflow-inbox-change', this.selected)
    }
  },

  watch: {
    variantKey: {
      handler() {
        this.fetchItems()
      }
    },
    workflowType: {
      handler() {
        this.fetchItems()
      }
    }
  }
}
</script>
<style scoped>
.email-select-ct {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

h3 {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: #4b515f;
}

.campaign-preview-option {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/preview/SidebarWorkflowInboxSelector.vue